/** Как Delphi GetUserLaw: отсутствующий бит = разрешено. */
export const getLawFlag = (law, index) => {
  if (!law || law.length <= index) return 1;
  const n = Number(law[index]);
  return Number.isFinite(n) ? n : 1;
};

export const MONTH_NAMES = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь"
];

export const WEEKDAY_LABELS = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"];

/** Локальная дата → yyyy-MM-dd. */
export function toDateKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function parseDateKey(key) {
  if (!key || typeof key !== "string") return null;
  const [y, m, d] = key.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

/** ISO/Date из API → yyyy-MM-dd. */
export function normalizeHolidayDateKey(value) {
  if (value == null) return null;
  if (typeof value === "string") {
    const m = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
    const dt = new Date(value);
    if (!Number.isNaN(dt.getTime())) return toDateKey(dt);
    return null;
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return toDateKey(value);
  }
  return null;
}

/**
 * Карта dateKey → { vid }.
 * Праздник (розовый): запись есть и vid !== 1.
 * Рабочий override: vid === 1.
 */
export function buildHolidayMap(list) {
  const map = new Map();
  if (!Array.isArray(list)) return map;
  for (const row of list) {
    const key = normalizeHolidayDateKey(row?.fdate ?? row?.Fdate);
    if (!key) continue;
    const vidRaw = row?.vid ?? row?.Vid;
    const vid = vidRaw == null || vidRaw === "" ? 0 : Number(vidRaw);
    map.set(key, { vid: Number.isFinite(vid) ? vid : 0 });
  }
  return map;
}

/** 0=Пн … 6=Вс для ячейки сетки (неделя с понедельника). */
export function mondayBasedWeekday(date) {
  const js = date.getDay(); // 0=Вс … 6=Сб
  return js === 0 ? 6 : js - 1;
}

/**
 * Ячейки месяца: 6 недель × 7 дней.
 * day = номер дня или null; dateKey для дней месяца.
 */
export function buildMonthCells(year, monthIndex) {
  const first = new Date(year, monthIndex, 1);
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
  const startPad = mondayBasedWeekday(first);
  const cells = [];
  for (let i = 0; i < startPad; i += 1) {
    cells.push({ day: null, dateKey: null, weekday: i });
  }
  for (let day = 1; day <= daysInMonth; day += 1) {
    const date = new Date(year, monthIndex, day);
    cells.push({
      day,
      dateKey: toDateKey(date),
      weekday: mondayBasedWeekday(date)
    });
  }
  while (cells.length % 7 !== 0) {
    cells.push({ day: null, dateKey: null, weekday: cells.length % 7 });
  }
  while (cells.length < 42) {
    cells.push({ day: null, dateKey: null, weekday: cells.length % 7 });
  }
  return cells;
}

/** Класс дня: fest | weekend | work | empty */
export function dayKind(dateKey, weekday, holidayMap) {
  if (!dateKey) return "empty";
  const entry = holidayMap.get(dateKey);
  if (entry) {
    if (entry.vid === 1) return "work";
    return "fest";
  }
  // weekday: 5=Сб, 6=Вс
  if (weekday === 5 || weekday === 6) return "weekend";
  return "work";
}
